/* eslint-disable import/no-anonymous-default-export */
import { cloneDeep } from 'lodash-es';
import { weekDays, getYearMonthDate } from '../calendar';
import { sortOrdersByDeliveryGroup } from './functions';

const DEFAULT_STATE = {
  orders: [],
};

// state key
export const orderSchedules = 'orderSchedules';

// actions
export const SET_ORDERS = 'order-schedule/set-orders';
export const SET_SUGGESTION = 'order-schedule/set-suggestion';
export const UPDATE_PICKUPTIME = 'order-schedule/update-pickuptime';
export const LOCK_SCHEDULE = 'order-schedule/lock-schedule';
export const UNLOCK_SCHEDULE = 'order-schedule/unlock-schedule';

// reducer
export default (state = DEFAULT_STATE, { type, payload }) => {
  switch (type) {
    case SET_ORDERS: {
      return {
        ...state,
        orders: payload.orders,
      };
    }

    case SET_SUGGESTION: {
      const { suggestions } = payload;
      const newOrders = cloneDeep(state.orders);
      suggestions.forEach((s) => {
        // find customer-serviceTime orders item
        let destOrders = newOrders.find(
          (o) =>
            o.customerId === s.customerId && o.serviceTime === s.serviceTime
        );

        if (destOrders) {
          s.menu.forEach((sgstMenu) => {
            let found = destOrders.menu.find(
              (dstMenu) =>
                dstMenu.date === sgstMenu.date &&
                dstMenu.menuType === sgstMenu.menuType
            );

            if (found) {
              if (!found.published && !found.lock) {
                Object.assign(found, sgstMenu);
              } else {
                // check logic!
                console.warn(
                  'check logic! published or locked orders suggested!'
                );
              }
            } else {
              destOrders.menu.push(sgstMenu);
            }
          });
        } else {
          // logically impossible
          newOrders.push(s);
        }
      });

      // sort
      sortOrdersByDeliveryGroup(newOrders);

      return {
        ...state,
        orders: newOrders,
      };
    }

    case UPDATE_PICKUPTIME: {
      const { customerId, date, serviceTime, menuId, pickupTime } = payload;

      const newOrders = state.orders.map((o) => {
        if (o.customerId === customerId && o.serviceTime === serviceTime) {
          const newCustomerOrders = cloneDeep(o);
          const found = newCustomerOrders.menu.find(
            (m) => m.date === date && m.menuId === menuId
          );
          found.pickupTime = pickupTime;
          return newCustomerOrders;
        } else {
          return o;
        }
      });

      return {
        ...state,
        orders: newOrders,
      };
    }

    case LOCK_SCHEDULE: {
      const { customerId, serviceTime, date } = payload;

      const days = weekDays(date).map((d) => getYearMonthDate(d));
      const newOrders = state.orders.map((o) => {
        if (o.customerId === customerId && o.serviceTime === serviceTime) {
          const newCustomerOrders = cloneDeep(o);
          newCustomerOrders.menu
            .filter((m) => days.includes(m.date))
            .forEach((m) => {
              m.lock = true;
            });
          return newCustomerOrders;
        } else {
          return o;
        }
      });

      return {
        ...state,
        orders: newOrders,
      };
    }

    case UNLOCK_SCHEDULE: {
      const { customerId, serviceTime, date } = payload;

      const days = weekDays(date).map((d) => getYearMonthDate(d));
      const newOrders = state.orders.map((o) => {
        if (o.customerId === customerId && o.serviceTime === serviceTime) {
          const newCustomerOrders = cloneDeep(o);
          newCustomerOrders.menu
            .filter((m) => days.includes(m.date))
            .forEach((m) => {
              m.lock = false;
            });
          return newCustomerOrders;
        } else {
          return o;
        }
      });

      return {
        ...state,
        orders: newOrders,
      };
    }

    default:
      return state;
  }
};

export const selectOrders = (state) => state.orderSchedules.orders;

export const selectCustomerLockedMeals = (state, customerId) => {
  // meal: date-serviceTime
  const meals = [];
  state.orderSchedules.orders
    .filter((o) => o.customerId === customerId)
    .forEach((o) => {
      o.menu.forEach((m) => {
        if (m.lock) {
          meals.push({
            date: m.date,
            serviceTime: o.serviceTime,
          });
        }
      });
    });
  return meals;
};
